import http from '@/http'
import formatDate from '@/utils/formatDate'

export default {
  namespaced: true,
  actions: {
    async createOrder(context, order) {
      const response = await http.post(`order/gas`, {
        assignId: order.assignId,
        customerId: order.customerId,
        productId: order.gasOrder.supplierProductId,
        calculator: {
          distributorId: order.gasOrder.distributorId,
          productId: order.gasOrder.currentSupplierProductId,
          areaId: order.gasOrder.areaId,
          personId: order.gasOrder.personId,
          usageIds: order.gasOrder.usageIds,
          postalCode: order.gasOrder.postalCode,
          consumption: order.gasOrder.consumption,
        },
        eic: order.gasOrder.eic,
        advanceAmount: order.gasOrder.advanceAmount,
        advancePeriod: order.gasOrder.advancePeriod,
        advanceType: order.gasOrder.advanceType,
        bankAccountNumber: order.gasOrder.bankAccountNumber,
        bankCode: order.gasOrder.bankCode,
        sipoNumber: order.gasOrder.sipoNumber,
        customerType: order.gasOrder.customerType,
        connectionBegin: formatDate(order.gasOrder.connectionBegin),
        contractEnd: formatDate(order.gasOrder.contractEnd),
        terminationPeriod: order.gasOrder.terminationPeriod,
        terminationPeriodType: order.gasOrder.terminationPeriodType,
        renewalPeriod: order.gasOrder.renewalPeriod,
        renewalPeriodUnit: order.gasOrder.renewalPeriodUnit,
        renewalPeriodType: order.gasOrder.renewalPeriodType,
        contractSigned: order.gasOrder.contractSigned,
        contractType: order.gasOrder.contractType,
        contractBonus: order.gasOrder.contractBonus,
        contractConcludingType: order.gasOrder.contractConcludingType,
        contractTerminationType: order.gasOrder.contractTerminationType,
        supplierChangeType: order.gasOrder.supplierChangeType,
        invoicePdf: order.gasOrder.invoicePdf,
        invoicePdfEmail: order.gasOrder.invoicePdfEmail,
        refund: order.gasOrder.refund,
        gdpr: order.gasOrder.gdpr,
        marketing: order.gasOrder.marketing,
        dataSentenceProduct: order.gasOrder.dataSentenceProduct,
        dataSentenceSupplierId: order.gasOrder.dataSentenceSupplierId,
        serviceProvideImmediately: order.gasOrder.serviceProvideImmediately,
        affidavitCustomerDied: order.gasOrder.affidavitCustomerDied,
        affidavitCustomerLeft: order.gasOrder.affidavitCustomerLeft,
        affidavitCustomerDate: formatDate(order.gasOrder.affidavitCustomerDate),
      })

      return response
    },
    async updateOrder(context, order) {
      const response = await http.put(`order/gas/${order.gasOrder.id}`, {
        productId: order.gasOrder.supplierProductId,
        calculator: {
          distributorId: order.gasOrder.distributorId,
          productId: order.gasOrder.currentSupplierProductId,
          areaId: order.gasOrder.areaId,
          personId: order.gasOrder.personId,
          usageIds: order.gasOrder.usageIds,
          postalCode: order.gasOrder.postalCode,
          consumption: order.gasOrder.consumption,
        },
        eic: order.gasOrder.eic,
        advanceAmount: order.gasOrder.advanceAmount,
        advancePeriod: order.gasOrder.advancePeriodName,
        advanceType: order.gasOrder.advanceTypeName,
        bankAccountNumber: order.gasOrder.bankAccountNumber,
        bankCode: order.gasOrder.bankCode,
        sipoNumber: order.gasOrder.sipoNumber,
        customerType: order.gasOrder.customerTypeName,
        connectionBegin: formatDate(order.gasOrder.connectionBegin),
        contractEnd: formatDate(order.gasOrder.contractEnd),
        terminationPeriod: order.gasOrder.terminationPeriod,
        terminationPeriodType: order.gasOrder.terminationPeriodTypeName,
        renewalPeriod: order.gasOrder.renewalPeriod,
        renewalPeriodUnit: order.gasOrder.renewalPeriodUnitName,
        renewalPeriodType: order.gasOrder.renewalPeriodTypeName,
        contractSigned: order.gasOrder.contractSigned,
        contractType: order.gasOrder.contractTypeName,
        contractBonus: order.gasOrder.contractBonus,
        contractConcludingType: order.gasOrder.contractConcludingTypeName,
        contractTerminationType: order.gasOrder.contractTerminationTypeName,
        supplierChangeType: order.gasOrder.supplierChangeTypeName,
        invoicePdf: order.gasOrder.invoicePdf,
        invoicePdfEmail: order.gasOrder.invoicePdfEmail,
        refund: order.gasOrder.refund,
        gdpr: order.gasOrder.gdpr,
        marketing: order.gasOrder.marketing,
        dataSentenceProduct: order.gasOrder.dataSentenceProduct,
        dataSentenceSupplierId: order.gasOrder.dataSentenceSupplierId,
        serviceProvideCity: order.gasOrder.serviceProvideCity,
        serviceProvideImmediately: order.gasOrder.serviceProvideImmediately,
        affidavitCustomerDied: order.gasOrder.affidavitCustomerDied,
        affidavitCustomerLeft: order.gasOrder.affidavitCustomerLeft,
        affidavitCustomerDate: formatDate(order.gasOrder.affidavitCustomerDate),
      })

      return response
    },
    async calculate(context, form) {
      const response = await http.post(`calculator/gas/calculate`, {
        postalCode: form.postalCode,
        consumption: form.consumption,
        distributorId: form.distributorId,
        supplierId: form.supplierId,
        supplierProductId: form.supplierProductId,
      })
      return response
    },
    async calculateState(context, input) {
      const response = await http.post(`calculator/gas/state`, {
        areaId: input.areaId,
        personId: input.personId,
        usageIds: input.usageIds,
      })
      return response
    },
    async getRanges() {
      const response = await http.get(`gas/range`)

      return response
    },
    async searchDistributor() {
      const response = await http.get(`distributor/search?type=GAS`)

      return response
    },
    async getDistributor(context, postalCode) {
      const response = await http.get(`distributor?postalCode=${postalCode}&type=GAS`)

      return response
    },
    async getSuppliers() {
      const response = await http.get(`supplier?type=GAS`)

      return response
    },
    async getSupplierProducts(context, { id, distributorId }) {
      const response = await http.get(
        `supplier/${id}/product?type=GAS&distributorId=${distributorId}`
      )

      return response
    },
  },
}
